import { Grid, Stack, Typography } from "@mui/material";
import styled from "styled-components";
import muiStyled from "@mui/system/styled";

const CoreValueSection = () => {
  const coreValues = [
    {
      isImage: true,
      image: "./assets/img/core-value-image-1.webp",
      size: 2
    },
    {
      isImage: false,
      size: 1,
      number: "01",
      title: "Our customers inspire us to deliver extraordinary solutions",
      description:
        "We listen, adapt, and go above and beyond to deliver what our customers need. Their success is our mission, and we don’t stop until we exceed their expectations."
    },
    {
      isImage: false,
      size: 1,
      number: "02",
      title: "Our curiosity drives us to explore what’s possible",
      description:
        "We believe in constant improvement. Moving forward is what matters, and we embrace change, knowing that progress beats standing still."
    },
    {
      isImage: true,
      image: "./assets/img/core-value-image-2.webp",
      size: 1
    },
    {
      isImage: false,
      size: 1,
      number: "03",
      title: "Our ownership empowers us to make an impact",
      description:
        "We take full responsibility for our work, owning every success and every challenge. With ownership comes the power to make real, lasting change for our team and customers."
    },
    {
      isImage: false,
      size: 2,
      number: "04",
      title: "Our commitment to excellence ensures we never compromise",
      description:
        "We hold ourselves to the highest standards because excellence is non-negotiable. Through meticulous attention to detail, we deliver nothing short of exceptional results."
    },
    {
      isImage: true,
      image: "./assets/img/core-value-image-3.webp",
      size: 1
    }
  ];

  return (
    <SectionContainer id={"core-value-section"}>
      <StyledTitle>Our Core Values</StyledTitle>

      <GridContainer container spacing={{ xs: "16px", sm: "32px" }}>
        {coreValues.map((value, index) => (
          <CoreValueContainer
            key={index}
            size={{
              xs: value.isImage ? 6 * value.size : 6,
              sm: value.size !== 1 ? 4 * value.size : 4
            }}
          >
            {value.isImage ? (
              <CoreValueImage src={value.image} alt={`Core Value ${index}`} />
            ) : (
              <CoreValueTextContainer
                direction={"column"}
                spacing={{
                  xs: "12px",
                  sm: "24px",
                  md: value.size === 1 ? "24px" : "48px"
                }}
              >
                <CoreItemNumber>{value.number}</CoreItemNumber>

                <CoreItemStack
                  direction={{
                    xs: "column",
                    sm: "column",
                    md: value.size === 1 ? "column" : "row"
                  }}
                  spacing={{
                    xs: "12px",
                    sm: "16px",
                    md: value.size === 1 ? "16px" : "32px"
                  }}
                >
                  <CoreItemTitle>"{value.title}"</CoreItemTitle>

                  <CoreItemDescription>{value.description}</CoreItemDescription>
                </CoreItemStack>
              </CoreValueTextContainer>
            )}
          </CoreValueContainer>
        ))}
      </GridContainer>
    </SectionContainer>
  );
};

const SectionContainer = styled.section`
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 48px;
  flex-direction: column;
`;

const StyledTitle = muiStyled(Typography)(({ theme }) => ({
  color: "#002376",
  fontFamily: "Switzer",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "52px",
  letterSpacing: "0.686px",
  fontSize: "28px",
  [theme.breakpoints.up("sm")]: {
    fontSize: "40px"
  }
}));

const GridContainer = muiStyled(Grid)(({ theme }) => ({
  width: "100%",
  maxWidth: "1250px",
  padding: "0 16px",
  [theme.breakpoints.up("sm")]: {
    padding: "0 32px"
  }
}));

const CoreValueContainer = muiStyled(Grid)(({ theme }) => ({
  height: "auto",
  display: "flex",
  flexDirection: "column"
}));

const CoreValueImage = styled.img`
  width: 100%;
  height: 100%;
`;

const CoreValueTextContainer = muiStyled(Stack)(({ theme }) => ({
  width: "100%",
  background: "#EFF4FF",
  borderRadius: "12px",
  maxWidth: "fit-content",
  height: "100%",
  padding: "18px",
  [theme.breakpoints.up("sm")]: {
    padding: "36px"
  }
}));

const CoreItemStack = muiStyled(Stack)(({ theme }) => ({
  width: "100%",
  alignItems: "center"
}));

const CoreItemNumber = muiStyled(Typography)(({ theme }) => ({
  color: "#0A40FF",
  fontFamily: "Switzer",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "12px",
  [theme.breakpoints.up("sm")]: {
    fontSize: "16px"
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "24px"
  }
}));

const CoreItemTitle = muiStyled(Typography)(({ theme }) => ({
  color: "#002376",
  fontFamily: "Switzer",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  [theme.breakpoints.up("sm")]: {
    fontSize: "20px",
    fontWeight: 400
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "30px"
  }
}));

const CoreItemDescription = muiStyled(Typography)(({ theme }) => ({
  color: "#3A5B98",
  fontFamily: "Switzer",
  fontSize: "10px",
  fontStyle: "normal",
  fontWeight: 400,
  [theme.breakpoints.up("sm")]: {
    fontSize: "14px"
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "16px"
  }
}));

export default CoreValueSection;
